import {
  GET_SAVED_COUPONS_REQUEST,
  GET_SAVED_COUPONS_SUCCESS,
  GET_SAVED_COUPONS_FAILURE,
  RESET_SAVED_COUPONS_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 15,
    pageIndex: 0,
    hasMore: null
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SAVED_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_SAVED_COUPONS_SUCCESS:
      return {
        data: [...state.data, ...action.payload],
        pagination: {
          ...action.pagination,
          hasMore: true
        },
        isFetched: true,
        isLoading: false,
        error: null
      };

    case GET_SAVED_COUPONS_FAILURE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          hasMore: false
        },
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case RESET_SAVED_COUPONS_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };

    default:
      return state;
  }
};
